class Forms {
    constructor() {
        // global class identifier
        this.class = {
            needsValidation: '.needs-validation',
            offcanvasInput: '.js__offcanvas__solr-suggest',
            modalInput: '.js__modal__solr-suggest',
            newsletterSubscriptionFormField: 'input.subscription-email-prefill',
            newsletterSubscriptionFormFieldError: 'input.subscription-email-validation-error',
            searchItem: '.js__search-item',
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
        } else {
            this.init();
        }
    }

    /**
     * Handle form validations.
     * On any validation error, set "was-validated" class to form
     */
    handleFormValidations() {
        const forms = document.querySelectorAll(this.class.needsValidation);

        if (!forms.length > 0) {
            return;
        }

        // iterate through elements in each form and listen to "invalid" event
        forms.forEach((form) => {
            form.querySelectorAll('select, textarea, input').forEach((formelement) => {
                formelement.addEventListener('invalid', (e) => {
                    if (!form.classList.contains('was-validated')) {
                        form.classList.add('was-validated');
                        form.classList.remove('needs-validation');
                        e.currentTarget.closest('.form-group').classList.remove('is-invalid');
                    }
                    e.currentTarget.closest('.form-group').classList.add('is-invalid');

                    // handle special case for radio button groups
                    if (e.target.type === 'radio') {
                        // find the closest parent with the button group class
                        const btnGroup = e.target.closest('.inputs-list');
                        if (btnGroup) {
                            // get the id of the btnGroup / .inputs-list element
                            const parentId = btnGroup.id;
                            const feedback = document.getElementById(`${parentId}-invalid-feedback-cb`);
                            feedback.setAttribute('aria-hidden', 'false');
                            feedback.removeAttribute('hidden');
                        }
                    }
                });
            });

            // on change required input fields: check for validity, set aria labels
            form.querySelectorAll('[required]:not([type="radio"])').forEach((formelement) => {
                formelement.addEventListener('change', (e) => {
                    const id = e.target.getAttribute('id');
                    this.setInvalidFeedbackAriaHidden(id);
                });
            });

            // handle special case "a group of required radio buttons"
            form.querySelectorAll('input[type="radio"][required]').forEach((formelementRadio) => {
                formelementRadio.addEventListener('change', (e) => {
                    const parent = e.target.closest('.inputs-list');
                    if (parent) {
                        // get the id of the parent / .inputs-list element
                        const parentId = parent.id;
                        const feedback = document.getElementById(`${parentId}-invalid-feedback-cb`);
                        feedback.setAttribute('aria-hidden', 'true');
                        feedback.setAttribute('hidden', 'hidden');
                    }
                });
            });

            // handle special case "multi checkboxes required"
            const multibleCheckBoxRequiredContainers = document.querySelectorAll('.inputs-list-mcbr');
            multibleCheckBoxRequiredContainers.forEach((inputsListMcbr) => {
                // collect checkboxes for "Array.from(checkboxes)"
                const checkboxes = inputsListMcbr.querySelectorAll('input[type="checkbox"]');
                checkboxes.forEach((checkbox) => {
                    checkbox.addEventListener('change', () => {
                        const isAnyChecked = Array.from(checkboxes)
                            .some((checkbox) => checkbox.checked);
                        const parentId = inputsListMcbr.id;
                        const feedback = document.getElementById(`${parentId}-invalid-feedback-cb`);
                        if (isAnyChecked) {
                            feedback.setAttribute('aria-hidden', 'true');
                            feedback.setAttribute('hidden', 'hidden');
                            feedback.style.display = 'none';
                        } else {
                            feedback.setAttribute('aria-hidden', 'false');
                            feedback.removeAttribute('hidden');
                            feedback.style.display = 'block';
                        }
                    });
                });
            });

            // on click submit button ("form submit"): check for required fields validity, set aria
            form.querySelectorAll('button[type="submit"]').forEach((formelement) => {
                formelement.addEventListener('click', (e) => {
                    // special case "radio buttons required"
                    form.querySelectorAll('[required]:not([type="radio"])').forEach((required) => {
                        const id = required.getAttribute('id');
                        this.setInvalidFeedbackAriaHidden(id);
                    });

                    // special case "multi checkboxes required"
                    multibleCheckBoxRequiredContainers.forEach((inputsListMcbr) => {
                        // collect checkboxes for "Array.from(checkboxes)"
                        const checkboxes = inputsListMcbr.querySelectorAll('input[type="checkbox"]');
                        const isAnyChecked = Array.from(checkboxes)
                            .some((checkbox) => checkbox.checked);
                        const parentId = inputsListMcbr.id;
                        const feedback = document.getElementById(`${parentId}-invalid-feedback-cb`);
                        if (!isAnyChecked) {
                            feedback.setAttribute('aria-hidden', 'false');
                            feedback.removeAttribute('hidden');
                            feedback.style.display = 'block';
                            // TODO: optimise this, because it ends the bootstrap validation
                            // (radiobutton mandatory e.g. not displayed)
                            document.getElementById(`${parentId}`)
                                .getElementsByClassName('form-group')[0]
                                .classList.add('is-invalid');
                            e.preventDefault();
                            e.stopPropagation();

                            // Try to find the first invalid input, select, or textarea
                            const firstInvalid = document.querySelector('input:invalid, select:invalid, textarea:invalid');

                            if (firstInvalid) {
                                // Scroll to and focus the first invalid element
                                firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                firstInvalid.focus();
                            } else {
                                // If no invalid elements, scroll to the div with id "parent"
                                const parentDiv = document.getElementById(`${parentId}`);
                                if (parentDiv) {
                                    parentDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                }
                            }
                        }
                    });
                });
            });
        });
    }

    /**
     * check bitv visibility of .invalid-feedback - set aria
     */
    // eslint-disable-next-line class-methods-use-this
    setInvalidFeedbackAriaHidden(id) {
        const inpObj = document.getElementById(id);
        const feedback = document.getElementById(`${id}-invalid-feedback`);

        if (inpObj.checkValidity() && feedback) {
            // input field
            inpObj.setAttribute('aria-invalid', 'false');
            const inpObjAriaFeedback = inpObj.getAttribute('aria-feedback') || '';
            this.removeAriaDescribedBy(inpObj, inpObjAriaFeedback);

            // feedback div
            feedback.setAttribute('aria-hidden', 'true');
            feedback.setAttribute('hidden', 'hidden');
        } else {
            // input field
            inpObj.setAttribute('aria-invalid', 'true');
            const inpObjAriaFeedback = inpObj.getAttribute('aria-feedback') || '';
            this.addAriaDescribedBy(inpObj, inpObjAriaFeedback);

            // feedback div
            feedback.setAttribute('aria-hidden', 'false');
            feedback.removeAttribute('hidden');
        }
    }

    /**
     * Function to add an ID to aria-describedby
     */
    // eslint-disable-next-line class-methods-use-this
    addAriaDescribedBy(element, newId) {
        const describedBy = element.getAttribute('aria-describedby') || '';
        const ids = describedBy.split(' ').filter(Boolean);
        if (!ids.includes(newId)) {
            ids.push(newId);
            element.setAttribute('aria-describedby', ids.join(' '));
        }
    }

    /**
     * Function to remove an ID from aria-describedby
     */
    // eslint-disable-next-line class-methods-use-this
    removeAriaDescribedBy(element, idToRemove) {
        const describedBy = element.getAttribute('aria-describedby') || '';
        let ids = describedBy.split(' ').filter(Boolean);
        ids = ids.filter((id) => id !== idToRemove);
        if (ids.length > 0) {
            element.setAttribute('aria-describedby', ids.join(' '));
        } else {
            element.removeAttribute('aria-describedby');
        }
    }

    /**
     * Set focus on search input
     */
    focusSearchInput() {
        const offcanvasInput = document.querySelector(this.class.offcanvasInput);
        const modalInput = document.querySelector(this.class.modalInput);
        const searchItem = document.querySelector(this.class.searchItem);

        // set autofocus offcanvas input only when search icon is clicked
        if (offcanvasInput && searchItem) {
            searchItem.addEventListener('click', () => {
                document.querySelector('#offcanvas').addEventListener('shown.bs.offcanvas', function setFocus(e) {
                    offcanvasInput.focus();
                    // removes the event listener after focus
                    e.currentTarget.removeEventListener('shown.bs.offcanvas', setFocus);
                });
            });
        }

        if (modalInput) {
            document.querySelector('#searchModal').addEventListener('shown.bs.modal', () => {
                modalInput.focus();
            });
        }

        // removes focus when offcanvas is closed
        document.querySelector('#offcanvas').addEventListener('hidden.bs.offcanvas', () => {
            offcanvasInput.blur();
        });
    }

    /**
     * Prefill Email field from url in newsletter subscription form
     */
    prefillNewsletterSubscriptionForm() {
        const field = document.querySelector(this.class.newsletterSubscriptionFormField);
        const getParameter = 'email';

        if (field) {
            let getValue = '';
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            getValue = urlParams.get(getParameter);
            if (getValue) {
                field.value = getValue;
            }
        }
    }

    /**
     * Display error msg in newsletter subscription form
     */
    errorNewsletterSubscriptionForm() {
        const field = document.querySelector(this.class.newsletterSubscriptionFormFieldError);

        if (field) {
            field.nextElementSibling.style.display = 'block';
        }
    }

    init() {
        this.handleFormValidations();
        this.focusSearchInput();
        this.prefillNewsletterSubscriptionForm();
        this.errorNewsletterSubscriptionForm();
    }
}

export default new Forms();
